import React, { memo } from "react";
import PropTypes from "prop-types";

const Loader = memo((relative) => {
	return (
		<div className="loaderWrapper">
			<div className={`loader active ${relative ? `relative` : ``}`} />
		</div>
	);
});
Loader.displayName = `Loader`;
Loader.propTypes = {
	relative: PropTypes.bool
};
export default Loader;
